"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/knock/types");
function isNotificationListActive() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.TOGGLE_NOTIFICATION_LIST) return action.payload;
  return state;
}
var _default = exports["default"] = isNotificationListActive;